<template>
  <div>
    <dx-grid
      :url="url"
      :columns="columns"
      :title="title"
      ref="grid"
      :actions="actions"
      :beforeSetupGrid="beforeSetupGrid"
      :onRowClicked="onRowClicked"
      navigationPath="onRowClicked"
      navigationField="onRowClicked"
      :expandedOptions="{
        enabled: true,
        allowExpandingAll: true,
        template: 'applicant-student-details',
      }"
    ></dx-grid>

    <v-dialog persistent v-model="votingDialog" max-width="1000">
      <voting-master-list-person
        :person="presonInfo"
        :reload="reload"
        :close="closeVotingDialog"
      ></voting-master-list-person>
    </v-dialog>

    <v-dialog v-model="vhDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="pl-0 pt-0 headline mb-2"
          >Update VH Status</v-card-title
        >
        <v-layout row class="mb-2">
          <div class="font-weight-medium mr-2">Account ID:</div>
          <div>{{ clickedRow.familyID }}</div>
        </v-layout>
        <v-layout row class="mb-2">
          <div class="font-weight-medium mr-2">Student ID:</div>
          <div>{{ clickedRow.studentID }}</div>
        </v-layout>
        <v-layout row class="mb-2">
          <div class="font-weight-medium mr-2">Student Name:</div>
          <div>
            {{ clickedRow.hebName + " " + clickedRow.lastNameH }}
          </div>
        </v-layout>
        <v-layout row class="mb-2">
          <div class="font-weight-medium mr-2">Father:</div>
          <div>
            {{ clickedRow.father }}
          </div>
        </v-layout>

        <div class="font-weight-medium mr-2">VM Status:</div>
        <div class="mb-2">
          {{ clickedRow.familyVMStatus }}
        </div>

        <v-select
          v-if="isAllowedUpdating()"
          v-model="clickedRow.vhStatus"
          label="Student VH Status"
          class="mb-2"
          :items="vhStatuses.map((s) => s.value)"
          clearable
        ></v-select>

        <v-textarea
          v-if="isAllowedUpdating()"
          v-model="clickedRow.vhNote"
          label="VH Note"
          rows="2"
          class="mb-2"
        ></v-textarea>

        <!-- <v-select
                    v-if="isAllowedUpdating()"
                    v-model="clickedRow.familyVHstatus"
                    label="Family VH Status"
                    class="mb-2"
                    :items="['OK', 'PROBLEM']"
                    clearable
                ></v-select> -->

        <!-- <v-select
                    v-model="clickedRow.familyVMStatus"
                    label="VM Status"
                    class="mb-2"
                    :items="['OK', 'PROBLEM']"
                    clearable
                ></v-select> -->

        <v-card-actions class="mr-0 mt-3">
          <v-spacer></v-spacer>
          <v-btn dark color="default" @click="vhDialog = false">Close</v-btn>
          <v-btn
            v-if="isAllowedUpdating()"
            color="success"
            :loading="processing"
            @click="save"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card></v-dialog
    >

    <v-dialog persistent v-model="assignAppointmentDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0 pb-2">{{
          clickedRow.appointmentDate
            ? "Unassign Appointment"
            : "Assign Appointment"
        }}</v-card-title>
        <div class="pb-3">
          {{ clickedRow.hebName + " " + clickedRow.lastNameH }}
        </div>

        <div v-if="!clickedRow.appointmentDate">
          <v-date-picker
            style="border: 2px solid #4caf50; border-radius: unset;"
            v-model="selectedAppointmentDate"
            class=""
            width="360"
            :events="appointmentSlotEvents"
            @input="appointmentDateSelected"
          ></v-date-picker>
          <v-select
            class="mt-3"
            v-model="selectedAppointmentTime"
            label="Time"
            :items="appointmentTimes"
          ></v-select>
        </div>
        <v-card-actions class="mx-0 px-2 pb-2 mt-2">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="reset()">Cancel</v-btn>
          <v-btn
            :loading="processing"
            color="success"
            v-if="!clickedRow.appointmentDate"
            @click="saveAppointment()"
          >
            Save
          </v-btn>
          <v-btn
            :loading="processing"
            color="success"
            v-if="clickedRow.appointmentDate"
            @click="unassignAppointment()"
          >
            Unassign Appointment
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="applicationInfoDialog" max-width="1300" persistent>
      <v-card style="height: 90vh; display: flex; flex-direction: column;">
        <v-card-title class="headline success white--text py-2">
          Application Information
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="closeApplicationInfoDialog"
            class="white--text my-0"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-2" style="flex: 1; overflow-y: auto;">
          <!-- Parent & Student Info Header - Read Only -->
          <div
            class="mb-3 pa-2"
            style="background-color: #f5f5f5; border-radius: 4px; font-size: 12px;"
          >
            <v-layout row wrap>
              <v-flex xs4>
                <div>
                  <span class="font-weight-medium">Name:</span>
                  {{ selectedStudent.hebName }} {{ selectedStudent.lastNameH }}
                </div>
                <div>
                  <span class="font-weight-medium">Father:</span>
                  {{ selectedStudent.father }}
                </div>
                <div>
                  <span class="font-weight-medium">Address:</span>
                  {{ selectedStudent.address1 }}
                </div>
              </v-flex>
              <v-flex xs4>
                <div>
                  <span class="font-weight-medium">Account ID:</span>
                  {{ selectedStudent.familyID }}
                </div>
                <div>
                  <span class="font-weight-medium">Home Phone:</span>
                  {{ selectedStudent.homePhone }}
                </div>
              </v-flex>
              <v-flex xs4>
                <div>
                  <span class="font-weight-medium">Paternal Grandparent:</span>
                  {{ selectedStudent.paternalGrandParent }}
                </div>
                <div>
                  <span class="font-weight-medium">Maternal Grandparent:</span>
                  {{ selectedStudent.maternalGrandParent }}
                </div>
              </v-flex>
            </v-layout>
          </div>

          <!-- 3 Column Layout -->
          <v-layout row wrap>
            <!-- Column 1 -->
            <v-flex xs4 class="pr-4">
              <!-- Father Information -->
              <div
                class="pa-3 mb-3"
                style="background-color: #f9f9f9; border: 1px solid #ddd; border-radius: 6px;"
              >
                <div class="font-weight-bold mb-2" style="font-size: 14px;">
                  טאטע
                </div>

                <v-combobox
                  ref="fatherCityCombo"
                  v-model="applicationInfo.fatherCity"
                  :items="fatherCityOptions"
                  label="טאטע געוואוינט אין"
                  dense
                  hide-details
                  class="mb-2"
                  clearable
                ></v-combobox>

                <v-combobox
                  ref="fatherSchoolCombo"
                  v-model="applicationInfo.fatherSchool"
                  :items="fatherSchoolOptions"
                  label="?טאטע איז א תלמיד פון חדר"
                  dense
                  hide-details
                  class="mb-2"
                  clearable
                ></v-combobox>

                <v-text-field
                  v-model="applicationInfo.fatherYeshivahKetana"
                  label="?טאטע איז א תלמיד פון ישיבה קטנה"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>

                <v-text-field
                  v-model="applicationInfo.fatherYeshivahGedolah"
                  label="?טאטע איז א תלמיד פון ישיבה גדולה"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>
              </div>

              <!-- Mother Information -->
              <div
                class="pa-3 mb-3"
                style="background-color: #f9f9f9; border: 1px solid #ddd; border-radius: 6px;"
              >
                <div class="font-weight-bold mb-2" style="font-size: 14px;">
                  מאמע
                </div>

                <v-combobox
                  ref="motherSchoolCombo"
                  v-model="applicationInfo.motherSchool"
                  :items="motherSchoolOptions"
                  label="?מאמע איז תלמידה פון"
                  dense
                  hide-details
                  class="mb-2"
                  clearable
                ></v-combobox>

                <v-text-field
                  v-model="applicationInfo.motherGraduatedYear"
                  label="?וועלכע יאר גענדיגט די 11 טע קלאס"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>
              </div>

              <!-- Landlord -->
              <div
                class="pa-3 mb-3"
                style="background-color: #f9f9f9; border: 1px solid #ddd; border-radius: 6px;"
              >
                <div class="font-weight-bold mb-2" style="font-size: 14px;">
                  Landlord
                </div>

                <v-text-field
                  v-model="applicationInfo.landlord"
                  label="Landlord"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>

                <v-text-field
                  v-model="applicationInfo.landlordPhone"
                  label="Landlord Phone"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>
              </div>

              <!-- Emergency Contact -->
              <div
                class="pa-3 mb-3"
                style="background-color: #f9f9f9; border: 1px solid #ddd; border-radius: 6px;"
              >
                <div class="font-weight-bold mb-2" style="font-size: 14px;">
                  Emergency Contact
                </div>

                <v-text-field
                  v-model="applicationInfo.inCaseOfEmergencyName"
                  label="Emergency Contact Name"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>

                <v-text-field
                  v-model="applicationInfo.inCaseOfEmergencyPhone"
                  label="Emergency Contact Phone #"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>
              </div>

              <!-- Country -->
              <div
                class="pa-3 mb-3"
                style="background-color: #f9f9f9; border: 1px solid #ddd; border-radius: 6px;"
              >
                <div class="font-weight-bold mb-2" style="font-size: 14px;">
                  Country
                </div>

                <v-text-field
                  v-model="applicationInfo.country"
                  label="Country"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>
              </div>
            </v-flex>

            <!-- Column 2 -->
            <v-flex xs4 class="pr-4">
              <!-- Work Information -->
              <div
                class="pa-3 mb-3"
                style="background-color: #f9f9f9; border: 1px solid #ddd; border-radius: 6px;"
              >
                <div class="font-weight-bold mb-2" style="font-size: 14px;">
                  ארבעט
                </div>

                <!-- Father's Work -->
                <div
                  class="font-weight-bold mb-2 mt-2"
                  style="font-size: 13px;"
                >
                  טאטע'ס ארבעט
                </div>

                <v-text-field
                  v-model="applicationInfo.workPlaceOrBoss"
                  label="ארבעט"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>

                <v-text-field
                  v-model="applicationInfo.workBoss"
                  label="נאמען פון בעה''ב"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>

                <v-select
                  v-model="applicationInfo.workType"
                  label="Work Type"
                  :items="workTypeOptions"
                  dense
                  hide-details
                  class="mb-2"
                  clearable
                ></v-select>

                <v-text-field
                  v-model="applicationInfo.workAddress"
                  label="Work Address"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>

                <v-text-field
                  v-model="applicationInfo.workPhone"
                  label="Work Phone #"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>

                <v-combobox
                  ref="workPositionCombo"
                  v-model="applicationInfo.workPosition"
                  :items="workPositionOptions"
                  label="Work Position"
                  dense
                  hide-details
                  class="mb-2"
                  clearable
                ></v-combobox>

                <v-text-field
                  v-model.number="applicationInfo.yearsInPosition"
                  label="Years In Position"
                  type="number"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>

                <!-- Mother's Work -->
                <div
                  class="font-weight-bold mb-2 mt-3"
                  style="font-size: 13px;"
                >
                  מאמע'ס ארבעט
                </div>

                <v-text-field
                  v-model="applicationInfo.wifeWorkPlaceOrBoss"
                  label="ארבעט"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>

                <v-text-field
                  v-model="applicationInfo.wifeWorkBoss"
                  label="נאמען פון בעה''ב"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>

                <v-select
                  v-model="applicationInfo.wifeWorkType"
                  label="Work Type"
                  :items="workTypeOptions.filter((v) => v != 'כולל')"
                  dense
                  hide-details
                  class="mb-2"
                  clearable
                ></v-select>

                <v-text-field
                  v-model="applicationInfo.wifeWorkAddress"
                  label="Work Address"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>

                <v-text-field
                  v-model="applicationInfo.wifeWorkPhone"
                  label="Work Phone #"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>

                <v-combobox
                  ref="wifeWorkPositionCombo"
                  v-model="applicationInfo.wifeWorkPosition"
                  :items="wifeWorkPositionOptions"
                  label="Work Position"
                  dense
                  hide-details
                  class="mb-2"
                  clearable
                ></v-combobox>

                <v-text-field
                  v-model.number="applicationInfo.wifeYearsInPosition"
                  label="Years In Position"
                  type="number"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>
              </div>
            </v-flex>

            <!-- Column 3 -->
            <v-flex xs4>
              <!-- שול און אידישקייט -->
              <div
                class="pa-3 mb-3"
                style="background-color: #f9f9f9; border: 1px solid #ddd; border-radius: 6px;"
              >
                <div class="font-weight-bold mb-2" style="font-size: 14px;">
                  ביהמ"ד
                </div>

                <v-text-field
                  v-model="applicationInfo.shabbatSynagogue"
                  label="וואכן ביהמ''ד"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>

                <v-text-field
                  v-model="applicationInfo.weekdaySynagogue"
                  label="שבת ביהמ''ד"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>

                <v-text-field
                  v-model="applicationInfo.dayan"
                  label="דיין"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>

                <v-checkbox
                  v-model="applicationInfo.isSatmarMember"
                  label="קיט''ל מעמבער"
                  color="success"
                  hide-details
                  class="mt-1 mb-2"
                ></v-checkbox>
              </div>

              <!-- קינדער -->
              <div
                class="pa-3 mb-3"
                style="background-color: #f9f9f9; border: 1px solid #ddd; border-radius: 6px;"
              >
                <div class="font-weight-bold mb-2" style="font-size: 14px;">
                  קינדער
                </div>

                <v-text-field
                  v-model.number="applicationInfo.kidsAtHome"
                  label="?וויפיל קינדער האט איר אין שטוב"
                  dense
                  hide-details
                  type="number"
                  class="mb-2"
                ></v-text-field>

                <v-checkbox
                  v-model="applicationInfo.kidsInOtherSchool"
                  label="?האט איר קינדער אין אנדערע מוסדות"
                  color="success"
                  hide-details
                  class="mb-2"
                ></v-checkbox>

                <v-combobox
                  ref="otherSchoolCombo"
                  v-model="applicationInfo.otherSchool"
                  :items="otherSchoolOptions"
                  label="נאמען פון מוסד"
                  dense
                  hide-details
                  class="mb-2"
                  clearable
                ></v-combobox>

                <v-combobox
                  ref="playGroupCombo"
                  v-model="applicationInfo.playGroup"
                  :items="playGroupOptions"
                  label="Play Group"
                  dense
                  hide-details
                  class="mb-2"
                  clearable
                ></v-combobox>
              </div>

              <!-- Benefits & Programs -->
              <div
                class="pa-3 mb-3"
                style="background-color: #f9f9f9; border: 1px solid #ddd; border-radius: 6px;"
              >
                <div class="font-weight-bold mb-2" style="font-size: 14px;">
                  Benefits & Programs
                </div>

                <v-text-field
                  v-model="applicationInfo.foodStampCase"
                  label="Food Stamp Case #"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>

                <v-select
                  v-model="applicationInfo.vouchers"
                  label="Vouchers"
                  :items="voucherTypeOptions"
                  dense
                  hide-details
                  class="mb-2"
                  clearable
                ></v-select>

                <v-textarea
                  v-model="applicationInfo.note"
                  label="Note"
                  rows="2"
                  outline
                  hide-details
                  class="mb-2"
                ></v-textarea>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="py-2 pr-1 my-2" style="flex-shrink: 0;">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="closeApplicationInfoDialog">
            Cancel
          </v-btn>
          <v-btn
            color="success"
            :loading="applicationInfoProcessing"
            @click="saveApplicationInfo"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import votingMasterListPerson from "../Votes/VotingMasterListPerson.vue";
import applicantStudentDetails from "../components/ApplicantStudentDetails.vue";
import { loadOptions } from "../../utils/smLookup.js";
import { groupBy } from "../../utils/helpers.js";

export default {
  components: {
    votingMasterListPerson,
    applicantStudentDetails,
  },
  data: () => ({
    title: "Applicant Students",

    actions: [],
    userBranch: "",
    url: "",
    regID: "",

    processing: false,
    selected: [],
    clickedRow: {},
    votingDialog: false,
    presonInfo: {},
    vhDialog: false,
    vhStatuses: [],

    date: "",

    assignAppointmentDialog: false,
    applicationInfoDialog: false,
    applicationInfoProcessing: false,
    applicationInfo: {},
    selectedStudent: {},
    otherSchoolOptions: [],
    playGroupOptions: [],
    voucherTypeOptions: [],
    motherSchoolOptions: [],
    fatherCityOptions: [],
    fatherSchoolOptions: [],
    workTypeOptions: [],
    workPositionOptions: [],
    wifeWorkPositionOptions: [],
    fatherCitySearch: null,
    fatherSchoolSearch: null,
    otherSchoolSearch: null,

    appointmentSlots: [],
    appointmentSlotEvents: [],
    appointmentTimes: [],
    selectedAppointmentDate: "",
    selectedAppointmentTime: "",

    rules: {
      required: (value) => !!value || "Required.",
    },

    columns: [
      {
        label: "Student ID",
        field: "studentID",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Last Name",
        field: "lastName",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "First Name",
        field: "engName",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Last Name H",
        field: "lastNameH",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "First Name H",
        field: "hebName",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "familyID",
        label: "Account ID",
        template: "link-action-cell-template",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        showLink: (row) => {
          return true;
        },
      },
      {
        field: "father",
        label: "Father",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "personID",
        label: "Ansl ID",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Applicant Info Fields",
        field: "applicantInfoCount",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        template: "link-action-cell-template",
        showLink: (row) => {
          return true;
        },
      },
      {
        field: "votingStatus",
        label: "Voting Status",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        template: "link-action-cell-template",
        showLink: (row) => {
          return true;
        },
      },
      {
        label: "Voucher Status",
        field: "voucherStatus",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Term",
        field: "regID",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Building",
        field: "building",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Branch",
        field: "branch",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Grade",
        field: "class",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Section",
        field: "section",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Home Phone",
        field: "homePhone",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Address",
        field: "address1",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "paternalGrandParent",
        label: "Paternal Grandparent",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "maternalGrandParent",
        label: "Maternal Grandparent",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Student VH Status",
        field: "vhStatus",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        template: "link-action-cell-template",
        showLink: (row) => {
          return true;
        },
      },
      {
        label: "VH Note",
        field: "vhNote",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Family VH Status",
        field: "familyVHstatus",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Family VM Status",
        field: "familyVMStatus",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Start Date",
        field: "startDate",
        type: "date",
        format: "MM/dd/yyyy",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Appointment Date",
        field: "appointmentDate",
        type: "date",
        format: "MM/dd/yyyy",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Appointment Time",
        field: "appointmentTime",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Time Sort",
        field: "timeSort",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Has Only Applicant Students",
        field: "hasOnlyApplicantStudents",
        format: "",
        type: "boolean",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Immunization",
        field: "imm",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
    ],
  }),
  watch: {},
  async created() {
    this.columns.find((c) => c.field == "votingStatus").linkAction = (row) => {
      this.openVotingDialog(row);
    };

    this.columns.find((c) => c.field == "familyID").linkAction = (account) => {
      this.toAccount(account);
    };

    this.columns.find((c) => c.field == "vhStatus").linkAction = (row) => {
      this.openVhDialog(row);
    };

    this.columns.find((c) => c.field == "applicantInfoCount").linkAction = (
      row
    ) => {
      this.openApplicationInfoDialog(row);
    };

    this.loadVhStatuses();

    this.loadAppointmentSlots();

    this.refreshApplicationInfoOptions();
  },
  beforeDestroy() {},
  methods: {
    async beforeSetupGrid() {
      this.url = "applicantStudents";
    },
    onRowClicked(row) {
      this.clickedRow = row;

      this.assignAppointmentDialog = true;
    },
    async loadAppointmentSlots() {
      const response = await this.$http.get(
        "api/appointments/loadExistingAppointments?source=NEW CHILD&branch=" +
          this.userBranch
      );

      this.appointmentSlots = response
        .filter((a) => !a.studentID)
        .map((appointment) => {
          appointment.date = moment(appointment.date).format("YYYY-MM-DD");

          appointment.title =
            appointment.time +
            (appointment.studentID
              ? " - " + appointment.hebName + " " + appointment.lastNameH
              : "");

          return appointment;
        });
      console.log(this.appointmentSlots);
      this.appointmentSlotEvents = Object.keys(
        groupBy(this.appointmentSlots, "date")
      ).map((key) => {
        const date = new Date(key);
        return date.toISOString().substr(0, 10);
      });
    },
    toAccount(row) {
      this.$router.push({
        name: "Account View",
        params: {
          id: row.familyID,
        },
        query: {
          limitView: true,
        },
      });
    },
    async loadVhStatuses() {
      this.vhStatuses = await loadOptions("VH Student Status");
    },
    async loadRegID() {
      this.regID = await this.$http.get("api/allStudents/getRegID");
    },
    async getTerms() {
      return await this.$http.get("api/allStudents/getRegTerms");
    },
    openVhDialog(row) {
      this.clickedRow = JSON.parse(JSON.stringify(row));

      this.vhDialog = true;
    },
    onTermSelected(value) {
      this.regID = value;

      let url =
        "allStudents?" +
        (this.userBranch != "null" ? "branch=" + this.userBranch : "branch=");

      this.url = url += "&grade=&section=&regID=" + this.regID;

      this.$refs.grid.reloadDataSource(this.url);
    },
    async openVotingDialog(row) {
      if (row.personID == "No Ansl ID") {
        // return this.$notify({
        //     group: "notification",
        //     text: "No Ansl ID",
        //     type: "warning",
        // });

        this.presonInfo = {
          firstEnglish: row.fatherEng,
          lastEnglish: "",
          titleHebrew: "",
          suffixHebrew: "",
          firstHebrew: row.father,
          lastHebrew: "",
          address1: row.address1,
          city: "",
          state: "",
          zip: "",
          father: "",
          fatherInLaw: "",
          parentId: row.familyID,
        };

        this.votingDialog = true;

        return;
      }

      this.presonInfo = await this.$http.get(
        "api/applicantStudents/getPersonByID?personID=" + row.personID
      );

      this.votingDialog = true;
    },
    closeVotingDialog() {
      this.votingDialog = false;
    },
    reload() {
      this.$refs.grid.reloadGrid();
    },
    showLink() {
      return (
        !this.$store.state.authentication.branch ||
        this.$store.state.authentication.branch == "null"
      );
    },
    isAllowedUpdating() {
      const roles = Array.isArray(this.$store.state.authentication.roles)
        ? this.$store.state.authentication.roles
        : this.$store.state.authentication.roles
        ? this.$store.state.authentication.roles.split(",")
        : [];

      return roles.includes("VH Status") || this.isAdmin();
    },
    isAdmin() {
      const isAdmin = this.$store.getters["authentication/isAdmin"];

      if (!isAdmin || isAdmin == "false") return false;

      return true;
    },
    async save() {
      try {
        this.processing = true;

        await this.$http.post("api/applicantStudents/save", this.clickedRow);

        this.vhDialog = false;
        this.processing = false;

        this.$notify({
          text: "Changes Saved",
          group: "notification",
          type: "success",
        });

        this.$refs.grid.reloadGrid();
      } catch (e) {
        this.processing = false;
      }
    },
    appointmentDateSelected(date) {
      this.appointmentTimes = this.appointmentSlots
        .filter((a) => a.date == date)
        .map((a) => a.time);
    },
    async saveAppointment() {
      if (!this.selectedAppointmentDate) {
        return this.$notify({
          text: "No Date Selected",
          group: "notification",
          type: "error",
        });
      }

      if (!this.selectedAppointmentTime) {
        return this.$notify({
          text: "No Time Selected",
          group: "notification",
          type: "error",
        });
      }

      const slot = this.appointmentSlots.find(
        (a) =>
          a.date == this.selectedAppointmentDate &&
          a.time == this.selectedAppointmentTime
      );

      if (!slot) return;

      try {
        this.processing = true;

        const appointment = JSON.parse(JSON.stringify(slot));

        appointment.studentID = this.clickedRow.studentID;
        appointment.familyID = this.clickedRow.familyID;
        appointment.source = "NEW CHILD";

        await this.$http.post("api/appointments/save", appointment);

        this.$refs.grid.reloadGrid();

        this.processing = false;

        this.reset();
      } catch (e) {
        this.processing = false;
      }
    },
    async unassignAppointment() {
      try {
        this.processing = true;

        const slot = await this.$http.get(
          "api/appointments/getByID?id=" + this.clickedRow.appointmentID
        );

        if (!slot) {
          this.processing = false;

          return;
        }
        const appointment = JSON.parse(JSON.stringify(slot));

        appointment.studentID = null;
        appointment.familyID = null;
        appointment.source = "NEW CHILD";

        await this.$http.post("api/appointments/save", appointment);

        this.$refs.grid.reloadGrid();

        this.processing = false;

        this.reset();
      } catch (e) {
        this.processing = false;
      }
    },
    reset() {
      this.assignAppointmentDialog = false;

      this.appointmentSlots = [];
      this.appointmentSlotEvents = [];
      this.appointmentTimes = [];
      this.selectedAppointmentDate = "";
      this.selectedAppointmentTime = "";

      this.loadAppointmentSlots();
    },
    async openApplicationInfoDialog(row) {
      this.selectedStudent = JSON.parse(JSON.stringify(row));
      this.applicationInfoDialog = true;
      this.applicationInfoProcessing = true;

      try {
        await this.refreshApplicationInfoOptions();

        // Fetch data from API instead of using row data
        const response = await this.$http.get(
          "api/newfamilyapplications/GetApplicationByAccountID?accountid=" +
            row.familyID
        );

        this.applicationInfo = {
          personID: row.personID,
          accountID: row.familyID,
          mothersName: response.mothersName || "",
          mothersNameHeb: response.mothersNameHeb || "",
          motherCell: response.motherCell || "",
          landlord: response.landlord || "",
          landlordPhone: response.landlordPhone || "",
          workPlaceOrBoss: response.workPlaceOrBoss || "",
          workBoss: response.workBoss || "",
          workAddress: response.workAddress || "",
          workPhone: response.workPhone || "",
          workType: response.workType || "",
          workPosition: response.workPosition || "",
          yearsInPosition: response.yearsInPosition || null,
          emailAddress: response.emailAddress || "",
          note: response.note || "",
          shabbatSynagogue: response.shabbatSynagogue || "",
          weekdaySynagogue: response.weekdaySynagogue || "",
          isSatmarMember: response.isSatmarMember || false,
          dayan: response.dayan || "",
          inCaseOfEmergencyName: response.inCaseOfEmergencyName || "",
          inCaseOfEmergencyPhone: response.inCaseOfEmergencyPhone || "",
          foodStampCase: response.foodStampCase || "",
          vouchers: response.vouchers || "",
          fatherCity: response.fatherCity || "",
          fatherSchool: response.fatherSchool || "",
          fatherYeshivahKetana: response.fatherYeshivahKetana || "",
          fatherYeshivahGedolah: response.fatherYeshivahGedolah || "",
          motherSchool: response.motherSchool || "",
          motherGraduatedYear: response.motherGraduatedYear || "",
          kidsAtHome: response.kidsAtHome || null,
          kidsInOtherSchool: response.kidsInOtherSchool || false,
          otherSchool: response.otherSchool || "",
          playGroup: response.playGroup || "",
          wifeWorkPlaceOrBoss: response.wifeWorkPlaceOrBoss || "",
          wifeWorkBoss: response.wifeWorkBoss || "",
          wifeWorkType: response.wifeWorkType || "",
          wifeWorkAddress: response.wifeWorkAddress || "",
          wifeWorkPhone: response.wifeWorkPhone || "",
          wifeWorkPosition: response.wifeWorkPosition || "",
          wifeYearsInPosition: response.wifeYearsInPosition || null,
          country: response.country || "",
        };
      } catch (e) {
        console.error("Failed to load application info", e);
        this.applicationInfo = {
          personID: row.personID,
          accountID: row.familyID,
        };
      } finally {
        this.applicationInfoProcessing = false;
      }
    },
    closeApplicationInfoDialog() {
      this.applicationInfoDialog = false;
      this.applicationInfo = {};
      this.selectedStudent = {};
    },
    async saveApplicationInfo() {
      try {
        this.applicationInfoProcessing = true;

        // Extract typed values from comboboxes
        if (
          this.$refs.fatherCityCombo &&
          this.$refs.fatherCityCombo.internalSearch
        ) {
          this.applicationInfo.fatherCity = this.$refs.fatherCityCombo.internalSearch;
        }
        if (
          this.$refs.fatherSchoolCombo &&
          this.$refs.fatherSchoolCombo.internalSearch
        ) {
          this.applicationInfo.fatherSchool = this.$refs.fatherSchoolCombo.internalSearch;
        }
        if (
          this.$refs.otherSchoolCombo &&
          this.$refs.otherSchoolCombo.internalSearch
        ) {
          this.applicationInfo.otherSchool = this.$refs.otherSchoolCombo.internalSearch;
        }
        if (
          this.$refs.playGroupCombo &&
          this.$refs.playGroupCombo.internalSearch
        ) {
          this.applicationInfo.playGroup = this.$refs.playGroupCombo.internalSearch;
        }
        if (
          this.$refs.motherSchoolCombo &&
          this.$refs.motherSchoolCombo.internalSearch
        ) {
          this.applicationInfo.motherSchool = this.$refs.motherSchoolCombo.internalSearch;
        }
        if (
          this.$refs.workPositionCombo &&
          this.$refs.workPositionCombo.internalSearch
        ) {
          this.applicationInfo.workPosition = this.$refs.workPositionCombo.internalSearch;
        }
        if (
          this.$refs.wifeWorkPositionCombo &&
          this.$refs.wifeWorkPositionCombo.internalSearch
        ) {
          this.applicationInfo.wifeWorkPosition = this.$refs.wifeWorkPositionCombo.internalSearch;
        }

        await this.$http.post(
          "api/applicantStudents/saveApplicationInfo",
          this.applicationInfo
        );

        this.applicationInfoProcessing = false;
        this.applicationInfoDialog = false;

        this.$notify({
          text: "Application Information Saved",
          group: "notification",
          type: "success",
        });

        this.$refs.grid.reloadGrid();
      } catch (e) {
        this.applicationInfoProcessing = false;

        this.$notify({
          text: "Error saving application information",
          group: "notification",
          type: "error",
        });
      }
    },
    async refreshApplicationInfoOptions() {
      await Promise.all([
        this.loadOtherSchoolOptions(),
        this.loadPlayGroupOptions(),
        this.loadVoucherTypeOptions(),
        this.loadMotherSchoolOptions(),
        this.loadFatherCityOptions(),
        this.loadFatherSchoolOptions(),
        this.loadWorkTypeOptions(),
        this.loadWorkPositionOptions(),
        this.loadWifeWorkPositionOptions(),
      ]);
    },
    async loadOtherSchoolOptions() {
      try {
        const response = await this.$http.get(
          "api/newfamilyapplications/GetUniquePropertyValues?propertyName=OtherSchool"
        );
        this.otherSchoolOptions = response || [];
      } catch (e) {
        console.error("Failed to load other school options", e);
        this.otherSchoolOptions = [];
      }
    },
    async loadFatherCityOptions() {
      try {
        const response = await this.$http.get(
          "api/newfamilyapplications/GetUniquePropertyValues?propertyName=FatherCity"
        );
        this.fatherCityOptions = response || [];
      } catch (e) {
        console.error("Failed to load father city options", e);
        this.fatherCityOptions = [];
      }
    },
    async loadMotherSchoolOptions() {
      try {
        const response = await this.$http.get(
          "api/newfamilyapplications/GetUniquePropertyValues?propertyName=MotherSchool"
        );
        this.motherSchoolOptions = response || [];
      } catch (e) {
        console.error("Failed to load mother school options", e);
        this.motherSchoolOptions = [];
      }
    },
    async loadFatherSchoolOptions() {
      try {
        const response = await this.$http.get(
          "api/newfamilyapplications/GetUniquePropertyValues?propertyName=FatherSchool"
        );
        this.fatherSchoolOptions = response || [];
      } catch (e) {
        console.error("Failed to load father school options", e);
        this.fatherSchoolOptions = [];
      }
    },
    async loadWorkTypeOptions() {
      try {
        const options = await loadOptions("ApplicantWorkType");
        this.workTypeOptions = options.map((o) => o.value);
      } catch (e) {
        console.error("Failed to load work type options", e);
        this.workTypeOptions = [];
      }
    },
    async loadWorkPositionOptions() {
      try {
        const response = await this.$http.get(
          "api/newfamilyapplications/GetUniquePropertyValues?propertyName=WorkPosition"
        );
        this.workPositionOptions = response || [];
      } catch (e) {
        console.error("Failed to load work position options", e);
        this.workPositionOptions = [];
      }
    },
    async loadWifeWorkPositionOptions() {
      try {
        const response = await this.$http.get(
          "api/newfamilyapplications/GetUniquePropertyValues?propertyName=WifeWorkPosition"
        );
        this.wifeWorkPositionOptions = response || [];
      } catch (e) {
        console.error("Failed to load wife work position options", e);
        this.wifeWorkPositionOptions = [];
      }
    },
    async loadPlayGroupOptions() {
      try {
        const response = await this.$http.get(
          "api/newfamilyapplications/GetUniquePropertyValues?propertyName=PlayGroup"
        );
        this.playGroupOptions = response || [];
      } catch (e) {
        console.error("Failed to load play group options", e);
        this.playGroupOptions = [];
      }
    },
    async loadVoucherTypeOptions() {
      try {
        const options = await loadOptions("VoucherType");
        this.voucherTypeOptions = (options || [])
          .map((o) =>
            typeof o === "string" ? o : o && (o.value || o.text || o.name)
          )
          .filter((o) => !!o);
      } catch (e) {
        console.error("Failed to load voucher type options", e);
        this.voucherTypeOptions = [];
      }
    },
  },
};
</script>
<style>
[v-cloak] {
  display: none;
}
.v-btn__content {
  color: unset;
}
</style>
